import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { AddGroupComposer } from "@/forms/rema/addGroup/composer"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Users } from "lucide-react"
import { useToast } from "@/contexts/ToastContext"

function AddGroupPage() {
  const navigate = useNavigate()
  const { toast } = useToast()

  return (
    <div className="p-6 space-y-4">
      <Card className="shadow-sm pb-0">
        <CardHeader className="border-b bg-slate-700 text-white [&_p]:text-slate-300">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <Users className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-xl">Add Group</CardTitle>
              <CardDescription className="text-base">Define a new RBAC group of users</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
      <Card className="shadow-sm">
        <CardContent className="p-6">
          <AddGroupComposer
            showHeader={false}
            onSuccess={() => navigate({ to: '/rema/groups' })}
            onError={(error) => toast({ title: 'Error', description: `Failed to create group: ${error.message}`, type: 'error' })}
            onCancel={() => navigate({ to: '/rema/groups' })}
          />
        </CardContent>
      </Card>
    </div>
  )
}

export const Route = createFileRoute("/rema/groups/add")({
  staticData: {
    title: 'Add Group',
    isSecured: true,
  },
  component: AddGroupPage,
})
